import { render } from "./TheSaleItems.vue?vue&type=template&id=55e3d262&scoped=true"
import script from "./TheSaleItems.vue?vue&type=script&lang=js"
export * from "./TheSaleItems.vue?vue&type=script&lang=js"

import "./TheSaleItems.vue?vue&type=style&index=0&id=55e3d262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e3d262"]])

export default __exports__